import { Utils } from "@/lib/utility/utils";
import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivClearanceViewModelGen,
  MrfiktivCreateClearanceResponseDtoGen,
  MrfiktivUpdateRepairEstimateResponseAcceptDtoGen
} from "../v1/data-contracts";
import { ClearanceRequest } from "../v1/ClearanceRequest"; // Adjusted import
import { HttpClient } from "../v1/http-client";

/**
 * Communicate with ClearanceRequest API
 */
class ClearanceRequestService {
  client: HttpClient;
  mrfiktivProxy: ClearanceRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.client = mrfiktivHttpClientProvider.client();
    this.mrfiktivProxy = new ClearanceRequest(this.client);
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceId
   * @param sct
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    clearanceId: string,
    sct: string
  ): Promise<MrfiktivClearanceViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceRequestControllerGet({
      partnerId,
      clearanceId,
      sct
    });

    return shared.data;
  }
  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param clearanceId
   * @param sct
   * @param data
   * @returns
   */
  async respondAccept(
    partnerId: string,
    clearanceId: string,
    sct: string,
    data: MrfiktivCreateClearanceResponseDtoGen
  ): Promise<MrfiktivClearanceViewModelGen> {
    const form = new FormData();
    const { imageIds, ...rest } = data;
    Utils.buildFormData(form, rest);
    if (imageIds) {
      imageIds.forEach((id, i) => form.append(`imageIds[${i}]`, id));
    }

    return (
      await this.client.instance.patch(`/partner/${partnerId}/clearance/${clearanceId}/request/confirm`, form, {
        params: { sct }
      })
    ).data;
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param repairEstimateId
   * @param token
   * @param data
   * @returns
   */
  async requestCostExtension(
    partnerId: string,
    clearanceId: string,
    token: string,
    data: MrfiktivUpdateRepairEstimateResponseAcceptDtoGen
  ): Promise<MrfiktivClearanceViewModelGen> {
    const shared = await this.mrfiktivProxy.clearanceRequestControllerRequestCostExtension(
      { partnerId, clearanceId, sct: token },
      data
    );

    return shared.data;
  }
}

/**
 * Communicate with ClearanceRequest API
 */
export default new ClearanceRequestService(new MrfiktivHttpClientProvider());
